<template>
    <div class="data-quality-container">
        <div class="data-quality-header">
            <h1 class="data-quality-title">건물 운영 관리 > 데이터 품질 관리</h1>
        </div>
        <div class="data-quality-content">
            <div class="calendar-section">
                <DataQualityCalendar ref="calendar" :selected-date="selectedDate" @date-selected="onDateSelected"
                    @month-changed="onMonthChanged" />
            </div>
            <div class="action-section">
                <div class="action-tabs">
                    <div class="tab-item" :class="{ active: activeTab === 'detail' }" @click="activeTab = 'detail'">
                        상세 정보
                    </div>
                    <div class="tab-item" :class="{ active: activeTab === 'actions' }" @click="activeTab = 'actions'">
                        작업 실행
                    </div>
                </div>
                <div class="tab-content">
                    <DataQualityDetail v-if="activeTab === 'detail'" :selected-date="selectedDate"
                        :detail-data="detailData" :loading="detailLoading" />
                    <DataQualityActions v-if="activeTab === 'actions'" :selected-date="selectedDate"
                        @action-executed="onActionExecuted" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import backEndApi from "@api/backEndApi.js";
import DataQualityCalendar from "./component/DataQualityCalendar.vue";
import DataQualityDetail from "./component/DataQualityDetail.vue";
import DataQualityActions from "./component/DataQualityActions.vue";

export default {
    name: "DataQualityMgmtPanel",
    components: {
        DataQualityCalendar,
        DataQualityDetail,
        DataQualityActions
    },
    data() {
        return {
            activeTab: "detail",
            selectedDate: null,
            detailData: null,
            detailLoading: false,
            currentMonth: new Date().getMonth() + 1,
            currentYear: new Date().getFullYear()
        };
    },
    mounted() {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        this.selectedDate = `${yyyy}${mm}${dd}`;
        this.loadDetailData(this.selectedDate);
    },
    methods: {
        onDateSelected(date) {
            this.selectedDate = date;
            this.loadDetailData(date);
        },
        onMonthChanged(month, year) {
            this.currentMonth = month;
            this.currentYear = year;
        },
        async loadDetailData(date) {
            if (!date) return;
            this.detailLoading = true;
            try {
                const response = await backEndApi.dataQuality.getDataQualityCalendarDetail(date);
                if (response.data && response.data.success) {
                    this.detailData = response.data;
                }
            } catch (error) {
                console.error("상세 데이터 로드 실패:", error);
            } finally {
                this.detailLoading = false;
            }
        },
        onActionExecuted() {
            // 액션 실행 후 캘린더와 상세 정보 갱신
            this.loadDetailData(this.selectedDate);
            this.$refs.calendar?.refreshCalendar?.();
        }
    }
};
</script>

<style scoped>
.data-quality-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 91vh;
    padding: 24px;
}

.data-quality-header {
    margin-bottom: 15px;
}

.data-quality-title {
    font-size: 15px;
    font-weight: 600;
    color: #111827;
    margin: 0;
}

.data-quality-content {
    display: flex;
    flex: 1;
    gap: 24px;
    min-height: 0;
}

.calendar-section {
    flex: 0 0 80%;
    min-height: 0;
    overflow: auto;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.action-section {
    flex: 0 0 20%;
    min-height: 0;
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    overflow: hidden;
}

.action-tabs {
    display: flex;
    border-bottom: 1px solid #e5e7eb;
    background: #fafafa;
}

.tab-item {
    flex: 1;
    padding: 12px 16px;
    text-align: center;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    color: #6b7280;
    border-bottom: 2px solid transparent;
    transition: all 0.2s;
}

.tab-item:hover {
    background: #f3f4f6;
    color: #374151;
}

.tab-item.active {
    color: #111827;
    border-bottom-color: #111827;
    background: #ffffff;
}

.tab-content {
    flex: 1;
    overflow: auto;
}
</style>